export default __webpack_public_path__ + "static/media/error.dfa0d304.svg";